export default __webpack_public_path__ + "static/media/ic-wallet.622d84f5.svg";